var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.classStyle,attrs:{"id":'border-' + this.direction + '-' + this.id}})}
var staticRenderFns = []

export { render, staticRenderFns }